var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44298 9C5.67792 9 5.86393 8.89278 6.09887 8.69295L9.76016 5.25688C9.93147 5.0863 10 4.90596 10 4.75C10 4.58916 9.93637 4.4137 9.76016 4.23825L6.09887 0.836296C5.83456 0.612099 5.68771 0.5 5.45277 0.5C5.11503 0.5 4.87518 0.768062 4.87518 1.08974V2.80046H4.74792C1.46353 2.80046 0 4.89622 0 8.28354C0 8.74169 0.234949 8.99513 0.509055 8.99513C0.71953 8.99513 0.939794 8.93664 1.10622 8.62959C1.88938 7.1723 2.98581 6.70442 4.74792 6.70442H4.87518V8.43463C4.87518 8.75631 5.11503 9 5.44298 9Z",
    fill: "#3456FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReply);
export default __webpack_public_path__ + "static/media/icon-reply.522e92829bff10932df4a76112b4ceaf.svg";
export { ForwardRef as ReactComponent };